export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            精选推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500 font-label">本周编辑精选影视内容推荐</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20collage%20with%20warm%20coral%20and%20amber%20lighting%2C%20dramatic%20composition%2C%20movie%20still%20aesthetic%2C%20dynamic%20energy%2C%20high%20contrast%2C%20no%20text%20or%20brands%2C%20dark%20cinematic%20background&width=900&height=500&seq=media-card-nc-01&orientation=landscape"
                alt="热门推荐 · 动作大片合集"
                className="w-full h-48 md:h-56 object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-3 left-4 right-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center backdrop-blur-sm">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-sm text-background-50 font-label font-medium">点击浏览详情</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-base text-foreground-800 group-hover:text-primary-700 transition-colors">
                热门推荐 · 动作大片合集
              </h3>
              <p className="mt-2 text-xs text-foreground-500 font-label leading-relaxed">
                精选近期最热动作电影，《速度与激情》系列、《碟中谍》系列等超清资源已更新，燃爆你的视觉体验。
              </p>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Mystery%20thriller%20cinematic%20visual%20with%20shadowy%20atmosphere%2C%20warm%20amber%20accents%2C%20film%20noir%20aesthetic%2C%20suspenseful%20mood%20lighting%2C%20abstract%20detective%20vibe%2C%20dark%20rich%20textures%2C%20no%20text%20or%20brands&width=900&height=500&seq=media-card-nc-02&orientation=landscape"
                alt="高分好评 · 悬疑推理剧场"
                className="w-full h-48 md:h-56 object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-3 left-4 right-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center backdrop-blur-sm">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-sm text-background-50 font-label font-medium">点击浏览详情</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-base text-foreground-800 group-hover:text-primary-700 transition-colors">
                高分好评 · 悬疑推理剧场
              </h3>
              <p className="mt-2 text-xs text-foreground-500 font-label leading-relaxed">
                烧脑悬疑剧集专题，《隐秘的角落》《白夜追凶》等豆瓣高分作品，考验你的推理能力。
              </p>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Bright%20cheerful%20comedy%20movie%20aesthetic%20with%20warm%20golden%20lighting%2C%20laughing%20atmosphere%2C%20soft%20coral%20and%20amber%20tones%2C%20entertainment%20studio%20vibe%2C%20colorful%20bokeh%20background%2C%20joyful%20mood%2C%20no%20text%20or%20brands&width=900&height=500&seq=media-card-nc-03&orientation=landscape"
                alt="轻松一刻 · 喜剧综艺精选"
                className="w-full h-48 md:h-56 object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-3 left-4 right-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center backdrop-blur-sm">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-sm text-background-50 font-label font-medium">点击浏览详情</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-base text-foreground-800 group-hover:text-primary-700 transition-colors">
                轻松一刻 · 喜剧综艺精选
              </h3>
              <p className="mt-2 text-xs text-foreground-500 font-label leading-relaxed">
                搞笑综艺和喜剧电影轮番上阵，工作学习之余放松身心，笑声不断让你忘记烦恼。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}